import React from 'react';
import { Card, CardContent } from './ui/card';
import { Wind, Sun, Battery, Users } from 'lucide-react';

export const Specialties = ({ specialties }) => {
  const icons = [Wind, Sun, Battery, Users];
  
  return (
    <section id="specialties" className="relative py-16 bg-white overflow-hidden -mt-16">
      {/* Energy Circuit Pattern */}
      <div className="absolute inset-0 opacity-[0.03]">
        <div className="absolute top-0 left-0 w-full h-full">
          <svg className="w-full h-full" viewBox="0 0 1200 800" fill="none">
            <path d="M100 100 L300 100 L300 200 L500 200 L500 300 L700 300" stroke="#64748b" strokeWidth="2" strokeDasharray="10,10" />
            <path d="M200 400 L400 400 L400 500 L600 500 L600 600 L800 600" stroke="#64748b" strokeWidth="2" strokeDasharray="10,10" />
            <circle cx="300" cy="100" r="8" fill="#16a34a" opacity="0.6" />
            <circle cx="500" cy="200" r="8" fill="#16a34a" opacity="0.6" />
            <circle cx="700" cy="300" r="8" fill="#16a34a" opacity="0.6" />
          </svg>
        </div>
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20 relative">
          {/* Solar carports background behind headline */}
          <div className="absolute inset-0 -top-16 -bottom-8 opacity-50 rounded-3xl overflow-hidden">
            <div 
              className="absolute inset-0 bg-cover bg-center bg-no-repeat"
              style={{
                backgroundImage: `url('https://customer-assets.emergentagent.com/job_clean-energy/artifacts/7tj42chw_solar_carports_5_home.jpg')`
              }}
            ></div>
          </div>
          
          <div className="relative z-10">
            <h2 className="text-4xl md:text-5xl font-light text-slate-900 mb-6 tracking-tight">
              Core Specialisations
            </h2>
            <p className="text-xl text-black font-light max-w-2xl mx-auto">
              Focused expertise in advanced renewable energy technologies.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {specialties.map((specialty, index) => {
            const IconComponent = icons[index];
            return (
              <div key={index} className="text-center group">
                <div className="relative w-20 h-20 flex items-center justify-center mx-auto mb-6">
                  {/* Industrial background circle */}
                  <div className="absolute inset-0 rounded-full bg-gradient-to-br from-slate-100 to-slate-200 group-hover:from-green-100 group-hover:to-green-200 transition-all duration-300"></div>
                  {/* Industrial grid overlay */}
                  <div className="absolute inset-2 rounded-full opacity-20" style={{
                    backgroundImage: 'radial-gradient(circle at 1px 1px, #64748b 1px, transparent 0)',
                    backgroundSize: '8px 8px'
                  }}></div>
                  <IconComponent className="relative h-10 w-10 text-slate-500 group-hover:text-green-600 transition-colors duration-300" />
                </div>
                <h3 className="text-lg font-medium text-slate-900 mb-4">
                  {specialty.title}
                </h3>
                <p className="text-slate-600 font-light leading-relaxed">
                  {specialty.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};